import React from 'react';
import { useLocation } from 'react-router-dom';
import Seo from './Seo';
import { NOT_FOUND_META, PAGE_META } from '../seo/siteConfig';

function RouteSeo() {
  const { pathname } = useLocation();
  const page = PAGE_META[pathname];

  if (page) {
    return (
      <Seo
        title={page.title}
        description={page.description}
        path={pathname}
        jsonLd={page.jsonLd || null}
      />
    );
  }

  return (
    <Seo
      title={NOT_FOUND_META.title}
      description={NOT_FOUND_META.description}
      path={pathname}
      noindex
    />
  );
}

export default RouteSeo;
